var map = {
	"./site-logo-desktop-alt.svg": 93986,
	"./site-logo-desktop-footer.svg": 12704,
	"./site-logo-desktop.svg": 29412,
	"./site-logo-mobile-drawer.svg": 89788,
	"./site-logo-mobile.svg": 65066,
	"./site-logo-sm.svg": 6392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40905;